import { Box } from 'components/Box';
import { Body } from 'components/Text/Body';
import { BodyLarge } from 'components/Text/BodyLarge';
import { RichText } from 'components/Text/RichText';
import { CmsApiBlockquoteBlockData } from 'modules/cms/api/types/blocks/CmsApiBlockquoteBlock';

type Props = {
  data: CmsApiBlockquoteBlockData;
};

export function CmsAmpBlockquoteBlock({ data: { quote, cite } }: Props) {
  return (
    <RichText>
      <Box component="blockquote">
        <BodyLarge
          dangerouslySetInnerHTML={{
            __html: quote,
          }}
        />
        {cite && (
          <Box mt="18px">
            <Body>{cite}</Body>
          </Box>
        )}
      </Box>
    </RichText>
  );
}
